import React from 'react';
import './styles.scoped.css';

const InfoTextField = ({ label, value, children, required = false, className = '', style = {} }) => (
  <div className={`info-text-field ${className}`} style={style}>
    <div className="label">
      {label}
      {required && <span className="required">*</span>}
    </div>
    <div className="value">{children ?? value}</div>
  </div>
);

export default InfoTextField;
